import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumOnlineReview } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

export const MAX_REVIEWS_COUNT = 10;

export const LocalOnlineReviews = ({ criterium }) => {
  const { data } = criterium;
  const { variant } = useReviewContext();

  const reviews = data.filter(directory => directory.type === 'Yelp');
  const content = (
    variant === 'nocrit'
      ? <CriteriumSkeleton width='60%' />
      : (
        <>
          {reviews.length > 0
            ? reviews.slice(0, MAX_REVIEWS_COUNT).map(review => (
              <CriteriumOnlineReview key={review.date} review={review} />
              ))
            : <Translate content='local_online_reviews_not_found' />}
        </>
        )
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

LocalOnlineReviews.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        author: PropTypes.string,
        date: PropTypes.number,
        link: PropTypes.string,
        rating: PropTypes.number,
        text: PropTypes.string
      })
    )
  })
};

export default React.memo(LocalOnlineReviews);
